import {css, StyleSheet} from 'aphrodite';
import React from 'react';

interface ChatEmptyStateProps {
  readonly?: boolean;
}

export function ChatEmptyState({readonly = false}: ChatEmptyStateProps): JSX.Element {
  const message = readonly ? "There's no chat here." : 'Type a message below to get started.';
  return <div className={css(styles.emptyState)}>{message}</div>;
}

const styles = StyleSheet.create({
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
